import {ForwardedRef, forwardRef} from 'react';
import {IconArrow} from '~/components/icons/IconArrow';
import {IconButton} from '~/components';
import {DATA_TEST_IDS} from '~/lib/const';

export const ArrowLeftButton = forwardRef(
  ({onClick}: {onClick?: () => void}, ref: ForwardedRef<HTMLButtonElement>) => {
    return (
      <IconButton
        testid={DATA_TEST_IDS.ICON('arrow-left')}
        ref={ref}
        onClick={onClick}
        ariaLabel="Previous items"
        ariaRole="button"
      >
        <IconArrow className="w-[8.48px] h-[16.06px] rotate-180 mr-[1px]" />
      </IconButton>
    );
  },
);
